import { render, staticRenderFns } from "./CustomerTaskList.vue?vue&type=template&id=1fa2568c&scoped=true&"
import script from "./CustomerTaskList.vue?vue&type=script&lang=js&"
export * from "./CustomerTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2568c",
  null
  
)

export default component.exports